import React, { useState, useCallback } from 'react'
import MusicPlayer from 'common/components/music-player/player';
import { ArtistSongGrid } from './artist-song-grid';

export const SongTab = ({artist, songsStore, playlistStore}) => {
    
    console.log(artist);
    // const songData = songsStore.getSongsByArtistID(artist._id).map(item => {
    //         return {
    //             _id: item._id,
    //             title: item.title,
    //             additionalArtists: item.name,
    //             releaseDate: new Date(item.releaseDate),
    //             ISRC: item.ISRC,
    //             explicit: item.explicit,
    //             duration: item.duration,
    //             active: item.active,
        
    //       }})


    const songList = songsStore.getSongsByArtistID(artist._id);
    const [currentSong, setCurrentSong] = useState(null);
    return (
        <div className='padding-left-1'>
            <ArtistSongGrid dataSource={songList} onRowClick={(rowData) => {
                playlistStore.setCurrentPlaylist({list: [rowData], name: '', imagePath:''});
            }} />
            <MusicPlayer/>
        </div>
    )
}